module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "g-bg-main"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_c('img', {
    staticClass: "evf_logo",
    attrs: {
      "src": "/static/assets/img/logo/OSEL Foundation_white_vertical.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container g-py-15"
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "section g-my-20"
  }, [(_vm.Account.accountType == 1) ? _c('h4', [_vm._v("INDIVIDUAL REGISTRATION DETAILS")]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 2) ? _c('h4', [_vm._v("PRACTICE/BUSINESS REGISTRATION DETAILS")]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 3) ? _c('h4', [_vm._v("NON-PROFIT REGISTRATION DETAILS")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('table', [_c('tbody', [_vm._m(1), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.Account.emailAddress))])]), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.Account.accountType == 1 && !_vm.Account.useLicenseNumber) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("NPI Number")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.Account.npiNumber))])]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 1 && _vm.Account.useLicenseNumber) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("License Number")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.Account.licenseNumber))])]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 1 || _vm.Account.accountType == 2) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Participant First Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.firstName))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Participant Last Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.lastName))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Suffix")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.suffix))])]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 3) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Primary Contact First Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.firstName))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Primary Contact Last Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.lastName))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Suffix")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.suffix))])]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 1) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Participant Phone Number")]), _vm._v(" "), _c('td', [_vm._v("(" + _vm._s(_vm.Account.primaryContact.countryCode) + ") " + _vm._s(_vm.Account.primaryContact.areaCode) + "-" + _vm._s(_vm.Account.primaryContact.phone))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Year Licensed")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.yearsInPractice))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Business Type")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.businessTypeDesc))])]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 2) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Participant Phone Number")]), _vm._v(" "), _c('td', [_vm._v("(" + _vm._s(_vm.Account.primaryContact.countryCode) + ") " + _vm._s(_vm.Account.primaryContact.areaCode) + "-" + _vm._s(_vm.Account.primaryContact.phone))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Legal Business Name")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.legalName))])]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 3) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Participant Phone Number")]), _vm._v(" "), _c('td', [_vm._v("(" + _vm._s(_vm.Account.primaryContact.countryCode) + ") " + _vm._s(_vm.Account.primaryContact.areaCode) + "-" + _vm._s(_vm.Account.primaryContact.phone))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Legal Organization Name (Participant)")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.legalName))])]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 2) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Business Type")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.businessTypeDesc))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Role in Business")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.titleDesc))])]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 3) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Organization Type")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.businessTypeDesc))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Role in Organization")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.titleDesc))])]) : _vm._e(), _vm._v(" "), _c('tr', [(_vm.Account.accountType == 1) ? _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Shipping Information")]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 2) ? _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Office Location Information")]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 3) ? _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Chapter Location Information")]) : _vm._e()]), _vm._v(" "), (_vm.Account.accountType == 2 && _vm.Account.primaryContact.isMultiLocation) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Office Location Name")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.name))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Street Address")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.streetAddress))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Suite")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.suite))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("City")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.city))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("State")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.state))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Zip Code")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.zip))])]), _vm._v(" "), ((_vm.Account.accountType == 2 || _vm.Account.accountType == 3) && !_vm.Account.primaryContact.isMultiLocation) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.countryCode) + " - " + _vm._s(_vm.Account.primaryContact.officeLocation.areaCode) + " - " + _vm._s(_vm.Account.primaryContact.officeLocation.phoneNumber))])]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 2 && _vm.Account.primaryContact.isMultiLocation) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.countryCode) + " - " + _vm._s(_vm.Account.primaryContact.officeLocation.areaCode) + " - " + _vm._s(_vm.Account.primaryContact.officeLocation.phoneNumber))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.emailAddress))])]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 2 && _vm.Account.primaryContact.isMultiLocation) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Office Contact First Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.contactFirstName))]), _vm._v(" "), _c('td', {
    staticClass: "caption"
  }, [_vm._v("Office Contact Last Name")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.contactLastName))])]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 2 && _vm.Account.primaryContact.isMultiLocation) ? _c('tr', [_c('td', {
    staticClass: "caption"
  }, [_vm._v("Role in Business")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.contactRoleDesc))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "caption",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Number of charitable orders this calendar year:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.numberOfJobs))])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.jobs.january))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.jobs.february))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.jobs.march))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.jobs.april))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.jobs.may))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.jobs.june))])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.jobs.july))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.jobs.august))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.jobs.september))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.jobs.october))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.jobs.november))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.primaryContact.officeLocation.jobs.december))])]), _vm._v(" "), (_vm.Account.accountType == 2 || _vm.Account.accountType == 3) ? _c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Eye Doctor Information")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.Account.eyeDoctors), function(item) {
    return (_vm.Account.accountType == 2 || _vm.Account.accountType == 3) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "6"
      }
    }, [_c('table', {
      staticStyle: {
        "margin-left": "0px",
        "width": "100%"
      }
    }, [_c('tr', [_c('td', {
      staticClass: "caption"
    }, [_vm._v("NPI Number")]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "5"
      }
    }, [_vm._v(_vm._s(item.npiNumber))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "caption",
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v("Doctor's First Name")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item.firstName))]), _vm._v(" "), _c('td', {
      staticClass: "caption",
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v("Doctor's Last Name")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item.lastName))]), _vm._v(" "), _c('td', {
      staticClass: "caption"
    }, [_vm._v("Suffix")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.suffix))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "caption",
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v("Doctor's Email Address")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(item.emailAddress))]), _vm._v(" "), _c('td', {
      staticClass: "caption",
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v("Year Licensed")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      },
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v(_vm._s(item.yearsInPractice))])])])])]) : _vm._e()
  }), _vm._v(" "), _c('tr', [(_vm.Account.accountType == 1 || _vm.Account.accountType == 2) ? _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Association Information and Communication Preferences")]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType == 3) ? _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Communication Preferences")]) : _vm._e()]), _vm._v(" "), (_vm.Account.accountType != 3) ? _c('tr', [_c('td', {
    staticClass: "caption",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Professional Organizations")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, _vm._l((_vm.Account.organizations.list), function(orgItem) {
    return _c('ul', [_c('li', [_vm._v(_vm._s(orgItem))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "caption",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Communication Preferences")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.toBeContactedAsVolunteer),
      expression: "Account.toBeContactedAsVolunteer"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.Account.toBeContactedAsVolunteer) ? _vm._i(_vm.Account.toBeContactedAsVolunteer, null) > -1 : (_vm.Account.toBeContactedAsVolunteer)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Account.toBeContactedAsVolunteer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Account, "toBeContactedAsVolunteer", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Account, "toBeContactedAsVolunteer", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Account, "toBeContactedAsVolunteer", $$c)
        }
      }
    }
  }), _vm._v(" I would like to be contacted if there are volunteer opportunities in my area."), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.toReceiveNewsLetter),
      expression: "Account.toReceiveNewsLetter"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.Account.toReceiveNewsLetter) ? _vm._i(_vm.Account.toReceiveNewsLetter, null) > -1 : (_vm.Account.toReceiveNewsLetter)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Account.toReceiveNewsLetter,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Account, "toReceiveNewsLetter", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Account, "toReceiveNewsLetter", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Account, "toReceiveNewsLetter", $$c)
        }
      }
    }
  }), _vm._v(" I would like email updates from OneSight EssilorLuxottica Foundation.\n                            ")])]), _vm._v(" "), _c('tr', [(_vm.Account.isCoveredUnderHIPAA) ? _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Terms & Conditions and BAA")]) : _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Terms & Conditions")])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "caption",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Participant Responsibilities Signature")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.participantResponsibilitiesSignature))]), _vm._v(" "), _c('td', {
    staticClass: "caption",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Date Signed")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.FormatDate(_vm.Account.participantResponsibilitiesDate)))])]), _vm._v(" "), (_vm.Account.isCoveredUnderHIPAA) ? _c('tr', [_vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.Account.isCoveredUnderHIPAA) ? _c('tr', [_c('td', {
    staticClass: "caption",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Business Associate Agreement Signature")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Account.businessAssociateAgreementSignature))]), _vm._v(" "), _c('td', {
    staticClass: "caption",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Date Signed")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.FormatDate(_vm.Account.businessAssociateAgreementDate)))])]) : _vm._e()], 2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section"
  }, [_c('input', {
    staticClass: "btn u-shadow-v33 g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-px-25 g-py-5",
    attrs: {
      "type": "button",
      "id": "btnPrint",
      "onclick": "javascript: window.print()",
      "value": "Print Form"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Username and Password")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Participant Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Jan")]), _vm._v(" "), _c('th', [_vm._v("Feb")]), _vm._v(" "), _c('th', [_vm._v("Mar")]), _vm._v(" "), _c('th', [_vm._v("Apr")]), _vm._v(" "), _c('th', [_vm._v("May")]), _vm._v(" "), _c('th', [_vm._v("Jun")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Jul")]), _vm._v(" "), _c('th', [_vm._v("Aug")]), _vm._v(" "), _c('th', [_vm._v("Sep")]), _vm._v(" "), _c('th', [_vm._v("Oct")]), _vm._v(" "), _c('th', [_vm._v("Nov")]), _vm._v(" "), _c('th', [_vm._v("Dec")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('p', [_vm._v("\n                                    This Agreement (“Contract”) consists of the following Terms and Conditions and referenced Business Associate Agreement. Please review and accept both documents in order to proceed with participation. If you have any questions, click here to contact us. "), _c('br')]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "left"
    }
  }, [_vm._v("\n                                    Terms and Conditions\n                                ")]), _vm._v(" "), _c('p', [_vm._v("\n                                    Please review and accept the below Terms and Conditions.\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "terms"
  }, [_c('p', [_vm._v("\n                                        Lorem ipsum dolor sit amet, veniam numquam has te. No suas nonumes recusabo mea, est ut graeci definitiones. His ne melius vituperata scriptorem, cum paulo copiosae conclusionemque at. Facer inermis ius in, ad brute nominati referrentur vis. Dicat erant sit ex. Phaedrum imperdiet scribentur vix no, ad latine similique forensibus vel.\n                                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                                        Dolore populo vivendum vis eu, mei quaestio liberavisse ex. Electram necessitatibus ut vel, quo at probatus oportere, molestie conclusionemque pri cu. Brute augue tincidunt vim id, ne munere fierent rationibus mei. Ut pro volutpat praesent qualisque, an iisque scripta intellegebat eam.\n                                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                                        Mea ea nonumy labores lobortis, duo quaestio antiopam inimicus et. Ea natum solet iisque quo, prodesset mnesarchum ne vim. Sonet detraxit temporibus no has. Omnium blandit in vim, mea at omnium oblique.\n                                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                                        Eum ea quidam oportere imperdiet, facer oportere vituperatoribus eu vix, mea ei iisque legendos hendrerit. Blandit comprehensam eu his, ad eros veniam ridens eum. Id odio lobortis elaboraret pro. Vix te fabulas partiendo.\n                                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                                        Natum oportere et qui, vis graeco tincidunt instructior an, autem elitr noster per et. Mea eu mundi qualisque. Quo nemore nusquam vituperata et, mea ut abhorreant deseruisse, cu nostrud postulant dissentias qui. Postea tincidunt vel eu.\n                                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                                        Ad eos alia inermis nominavi, eum nibh docendi definitionem no. Ius eu stet mucius nonumes, no mea facilis philosophia necessitatibus. Te eam vidit iisque legendos, vero meliore deserunt ius ea. An qui inimicus inciderint.\n                                    ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "left"
    }
  }, [_vm._v("Participant Responsibilities:")]), _vm._v(" "), _c('p', [_vm._v("\n                                    Please review and select each of the following responsibilities (from the above Terms and Conditions) to confirm your agreement: Please note, you will not be able to submit the form if you do not click \"I Agree\" beneath each item.\n                                ")]), _vm._v(" "), _c('p', [_vm._v("\n                                    Participant agrees to co-brand and promote Essilor Vision Foundation as a charitable partner, specifically, but not limited to Essilor Vision Foundation logo included on Participant Program Materials and agrees to submit to Essilor Vision Foundation, any requests for additional trademarks, copy or content needed for individual events or media for Essilor Vision Foundation’s approval prior to publication\n                                ")]), _vm._v(" "), _c('p', [_vm._v("\n                                    Participant agrees to commit to the use of the ECP Portal and lenses for charitable vision services\n                                ")]), _vm._v(" "), _c('p', [_vm._v("\n                                    Participant agrees to validate the patient need through an indirect referral network or directly through vetting by the Participant which shall include: income below poverty level, lack of insurance and/or lack of lens benefit\n                                ")]), _vm._v(" "), _c('p', [_vm._v("\n                                    Participant agrees to ensure that no charge is accepted or marketed, specific to the lens product delivered; however, Participant is able to charge up to, but not to exceed, the cost of the frame when there is a cost associated with the frame\n                                ")]), _vm._v(" "), _c('p', [_vm._v("\n                                    Participant agrees to retain an electronic log outlining to whom Essilor Vision Foundation services were provided. Information may include, but is not limited to: date of service, number/name of patient examined with validation of need, number of exams, number of patients who received glasses, total number of glasses dispensed, and number of patients receiving glasses for the first time. The electronic log must be kept available during the term of the Contract for audit purposes and other treatment and health care operation purposes further described in the accompanying BAA, as Essilor Vision Foundation may request from time to time during the Term.\n                                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "left"
    }
  }, [_vm._v("\n                                    Business Associate Agreement\n                                ")]), _vm._v(" "), _c('p', [_vm._v("\n                                    Please review and accept the terms of the below Business Associate Agreement.\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "terms"
  }, [_c('p', [_vm._v("\n                                        Lorem ipsum dolor sit amet, veniam numquam has te. No suas nonumes recusabo mea, est ut graeci definitiones. His ne melius vituperata scriptorem, cum paulo copiosae conclusionemque at. Facer inermis ius in, ad brute nominati referrentur vis. Dicat erant sit ex. Phaedrum imperdiet scribentur vix no, ad latine similique forensibus vel.\n                                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                                        Dolore populo vivendum vis eu, mei quaestio liberavisse ex. Electram necessitatibus ut vel, quo at probatus oportere, molestie conclusionemque pri cu. Brute augue tincidunt vim id, ne munere fierent rationibus mei. Ut pro volutpat praesent qualisque, an iisque scripta intellegebat eam.\n                                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                                        Mea ea nonumy labores lobortis, duo quaestio antiopam inimicus et. Ea natum solet iisque quo, prodesset mnesarchum ne vim. Sonet detraxit temporibus no has. Omnium blandit in vim, mea at omnium oblique.\n                                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                                        Eum ea quidam oportere imperdiet, facer oportere vituperatoribus eu vix, mea ei iisque legendos hendrerit. Blandit comprehensam eu his, ad eros veniam ridens eum. Id odio lobortis elaboraret pro. Vix te fabulas partiendo.\n                                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                                        Natum oportere et qui, vis graeco tincidunt instructior an, autem elitr noster per et. Mea eu mundi qualisque. Quo nemore nusquam vituperata et, mea ut abhorreant deseruisse, cu nostrud postulant dissentias qui. Postea tincidunt vel eu.\n                                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                                        Ad eos alia inermis nominavi, eum nibh docendi definitionem no. Ius eu stet mucius nonumes, no mea facilis philosophia necessitatibus. Te eam vidit iisque legendos, vero meliore deserunt ius ea. An qui inimicus inciderint.\n                                    ")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c7c42dd0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7c42dd0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/RegistrationSummary.vue
// module id = 549
// module chunks = 3